import React, { useState } from 'react';
import { networkErroLabels } from "../components/ScreenLabels";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const NetworkError = (props) => {
  const [errorPopup, setErrorPopup] = useState(true);
  const onClickOk = () => {
    setErrorPopup(false);
    if(props.setNetworkPopup){
      props.setNetworkPopup(false);
    }
  }

  return (
    <>
      {errorPopup && <div className='card-network-popup-overlay'>
        <div className='text-center'>
          {/* <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> */}
          <FontAwesomeIcon icon={faExclamationTriangle} />
          <div className='card-overlay-popup-text'>
            {networkErroLabels.networkMsg}
          </div>
          <button className='ok-button' onClick={() => onClickOk()}>{networkErroLabels.okButtonText}</button>
        </div>
      </div>}
    </>
  )
}

export default NetworkError;